// src/components/network/ForfeoNetworkBadges.tsx
import { CheckCircle2, QrCode, ShieldCheck, Smartphone, WalletCards } from 'lucide-react';

type ForfeoNetworkBadgesProps = {
  variant?: 'compact' | 'full';
  className?: string;
};

const trustBadges = [
  {
    label: 'Certifié Forfeo',
    short: 'Certifié',
    icon: CheckCircle2,
    tone: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  },
  {
    label: 'QR sécurisé',
    short: 'QR',
    icon: QrCode,
    tone: 'bg-blue-50 text-blue-700 border-blue-200',
  },
  {
    label: 'Wallet mobile prêt',
    short: 'Wallet',
    icon: WalletCards,
    tone: 'bg-violet-50 text-violet-700 border-violet-200',
  },
  {
    label: 'Garanti par Forfeo',
    short: 'Garanti',
    icon: ShieldCheck,
    tone: 'bg-amber-50 text-amber-700 border-amber-200',
  },
];

export function ForfeoNetworkBadges({ variant = 'compact', className = '' }: ForfeoNetworkBadgesProps) {
  const visibleBadges = variant === 'compact' ? trustBadges.slice(0, 3) : trustBadges;

  return (
    <div className={`flex flex-wrap gap-2 ${className}`.trim()}>
      {visibleBadges.map((badge) => {
        const Icon = badge.icon;
        return (
          <span
            key={badge.label}
            className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[10px] font-black uppercase tracking-[0.14em] ${badge.tone}`}
            title={badge.label}
          >
            <Icon size={12} />
            <span>{variant === 'compact' ? badge.short : badge.label}</span>
          </span>
        );
      })}
      {variant === 'full' && (
        <span className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-[10px] font-black uppercase tracking-[0.14em] text-slate-600">
          <Smartphone size={12} /> App Forfeo
        </span>
      )}
    </div>
  );
}

export default ForfeoNetworkBadges;
